module.exports = __webpack_public_path__ + "static/media/camera.f3c030be.svg";